import ServiceCRUD from '../../../services/ServiceCRUDFLEXCHAT';
import { apiInstagramChat } from '../../../http';

class FlexIAService extends ServiceCRUD {
  constructor() {
    super('/flexia');
  }

  async createFlexia(data) {
    return apiInstagramChat.post(`/configurations/flexiaconfig`, data);
  }

  async getAllFlexia(page, size, query, { showDisable = false }) {
    if (query !== '') {
      return apiInstagramChat.get(
        `/configurations/flexiaconfig?name=${query}&showDisable=${showDisable}`,
        {
          headers: {
            limit: size,
            offset: size * (page - 1)
          }
        }
      );
    } else if (showDisable) {
      return apiInstagramChat.get(
        `/configurations/flexiaconfig?showDisable=${showDisable}`,
        {
          headers: {
            limit: size,
            offset: size * (page - 1)
          }
        }
      );
    } else {
      return apiInstagramChat.get(`/configurations/flexiaconfig`, {
        headers: {
          limit: size,
          offset: size * (page - 1)
        }
      });
    }
  }

  async getFlexiaById(id) {
    return apiInstagramChat.get(`/configurations/flexiaconfig/${id}`);
  }

  async putFlexiaById(id, data) {
    return apiInstagramChat.put(`/configurations/flexiaconfig/${id}`, data);
  }

  async deleteFlexiaById(id) {
    return apiInstagramChat.delete(`/configurations/flexiaconfig/${id}`);
  }
  async enableFlexiaById(id, newStatus) {
    return apiInstagramChat.patch(
      `/configurations/flexia/switch/disable/${id}`,
      {
        disable: newStatus
      }
    );
  }
}
export default new FlexIAService();
